import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
const MATTERS = [{
  label: 'SMSF purchases',
  href: '/smsf-trust-property'
}, {
  label: 'Family and discretionary trusts',
  href: '/smsf-trust-property'
}, {
  label: 'Unit trusts',
  href: '/smsf-trust-property'
}, {
  label: 'Commercial property',
  href: '/commercial-property'
}, {
  label: 'Commercial leases',
  href: '/commercial-property'
}, {
  label: 'Property transfers',
  href: '/property-transfers'
}, {
  label: 'Subdivisions',
  href: '/subdivisions'
}, {
  label: 'Solicitor certificates',
  href: '/solicitor-certificates'
}];
export function ComplexMatters() {
  return <section className="py-10 md:py-14 px-5 md:px-6 bg-ink text-cream" data-id="element-218" data-mp="1ttv2jphthmdd">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-center" data-id="element-219" data-mp="3a4p8b6t6fjy1">
        <div data-id="element-220" data-mp="3564atf5b7eda">
          <p className="eyebrow text-peach mb-1" data-id="element-221" data-mp="356nscur1s0qs">
            beyond the basics
          </p>
          <h2 className="font-serif text-3xl md:text-[2.6rem] leading-tight text-cream" data-id="element-222" data-mp="3099iw5u69wsb">
            More than standard conveyancing.
          </h2>
          <p className="mt-6 text-lg text-cream/70 leading-relaxed" data-id="element-223" data-mp="399pk18ng0ru0">
            Some purchases carry extra moving parts. Complex structures may need
            coordination with your accountant, financial adviser and lender, and
            we work alongside them so nothing falls between the cracks.
          </p>
        </div>

        <div data-id="element-224" data-mp="2lleoml0inkd4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-225" data-mp="2ll6ev1zowv65">
            {MATTERS.map(m => <Link key={m.label} to={m.href} className="group flex items-center justify-between rounded-2xl bg-white/[0.04] border border-white/10 px-5 py-4 transition-colors hover:bg-white/[0.08] hover:border-accent/40" data-id="element-226" data-mp="2qiev2x1a2p4r">
                <span className="text-cream/90" data-id="element-227" data-mp="22skk6l0iran5">{m.label}</span>
                <ArrowRight className="w-4 h-4 text-peach opacity-0 -translate-x-1 transition-all group-hover:opacity-100 group-hover:translate-x-0" data-id="element-228" data-mp="1usxpcexvkd52" />
              </Link>)}
          </div>
          <p className="mt-5 text-sm text-cream/50" data-id="element-229" data-mp="24jsdjouolmt5">
            Note: we coordinate with your advisers but do not provide tax or
            financial advice.
          </p>
        </div>
      </div>
    </section>;
}